<template>
  <div
    v-for="(error, index) in errors"
    :key="index"
    class="label-s-regular error-text"
  >
    {{ error }}
  </div>
</template>

<script>
export default {
  name: 'InputErrors',
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.error-text {
  margin-top: var(--space-1);
  margin-left: var(--space-2);
  color: var(--chicago-dog-red-1000);
  border: 1px solid transparent;
}
.error-text:first-of-type {
  margin-top: var(--space-2);
}
</style>
